<template>
	<div class="footerBox">
		<div class="linkList">
			<div class="centerBox">
				<span>友情链接:</span>
				<a href="http://www.sdsteel.cc">山东钢铁集团有限公司</a>
				<a href="http://www.laigang.com">莱芜钢铁集团有限公司</a>
				<a href="http://www.jigang.com.cn">济钢集团有限公司</a>
				<a href="http://www.sgjrkg.cn">山钢资本控股（深圳）有限公司</a>
				<a href="http://www.sdsteelrz.com">山东钢铁集团日照有限公司 </a>
				<a href="http://www.lcc.cn">山东莱钢建设有限公司</a>
			</div>
		</div>
		<div class="aboutUsBox">
			<div class="centerBox">
				<div class="footLeftBox">
					<img class="footLogo" src="@/assets/images/foot-logo.png" alt="">
					<div class="internalLink">
						<a :href="this.$store.state.oldhttpUrl+'index.html#allInfo'">舜信首页</a>
						<a :href="this.$store.state.oldhttpUrl+'aboutUsBasePage.html'">关于我们</a>
						<a :href="this.$store.state.oldhttpUrl+'helpPage.html'">帮助中心</a>
						<a :href="this.$store.state.oldhttpUrl+'supplyChainFinanceIndex.html'">山钢供应链</a>
					</div>
				</div>
				<div class="footCenterBox">
					<div class="numAndTime">
						<p class="num">400-960-0388</p>
						<p class="time">（法定工作日9:00-17:30）</p>
					</div>
					<div class="address">
						<p>服务邮箱：site@sgscf.com</p>
						<p>公司地址：深圳市前海深港合作区南山街道梦海大道5035号前海华润金融中心T5写字楼1707B单元</p>
					</div>
				</div>
				<div class="footRightBox">
					<img src="@/assets/images/footer02.jpg" alt="">
					<p>关注“山钢供应链”公众号</p>
				</div>
			</div>
		</div>
		<div class="copyRightBox">
			山钢供应链管理（深圳）有限公司© 2019 www.sgscf.com |
			<a target="_blank" style=" text-decoration: none;color: #b0b0b0" href="http://beian.miit.gov.cn">
				备案号：粤ICP备16012898号-4
			</a>
			<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502009186" style="display:inline-block;text-decoration:none;height:15px;line-height:20px; margin-left: 20px;">
				<img src="@/assets/images/bAImage.png" style="float:left;">粤公网安备 44030502009186号
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		props: [],
		data() {
			return {}
		},
		mounted() {

		},
		methods: {

		},
	}
</script>

<style scoped="scoped" lang="scss">
	.footerBox {
		.linkList{
			padding: 13px 0;
			background-color: #313131;
			span,a{
				display: inline-block;
				vertical-align: middle;
				line-height: 25px;
				margin-right: 34px;
			}
			span{
				color: #cc7b0d;
				font-size: 15px;
			}
			a{
				color: #c1c1c1;
			}
		}
		.aboutUsBox{
			padding: 64px 0 90px 0;
			background-color: #1f1f1f;
			.footLeftBox,.footCenterBox,.footRightBox{
				display: inline-block;
				vertical-align: top;
			}
			.footLeftBox{
				width: 430px;
				.footLogo{
					display: block;
				}
				.internalLink{
					margin-top: 40px;
					a{
						display: inline-block;
						vertical-align: top;
						margin-right: 14px;
						color: #c8c8c8;
						font-weight: bold;
						font-size: 15px;
						position: relative;
						&::after{
							content: '';
							position: absolute;
							width: 1px;
							height: 15px;
							background-color: #626262;
							right: -7px;
							top: 4px;
						}
						&:last-child:after{
							display: none;
						}
					}
				}
			}
			.footCenterBox{
				width: 590px;
				.numAndTime{
					.num{
						font-size: 30px;
						color: #e8c7a6;
						line-height: 32px;
						display: inline-block;
						vertical-align: bottom;
					}
					.time{
						color: #b0b0b0;
						margin-left: 10px;
						display: inline-block;
						vertical-align: bottom;
					}
				}
				.address{
					margin-top: 25px;
					p{
						line-height: 15px;
						font-size: 15px;
						color: #b0b0b0;
						margin-bottom: 10px;
					}
				}
			}
			.footRightBox{
				float: right;
				text-align: center;
				img{
					width: 122px;
					height: 122px;
					margin-bottom: 8px;
				}
				p{
					text-align: center;
					color: #fff;
					font-size: 14px;
				}
			}
		}
		.copyRightBox{
			height: 52px;
			line-height: 52px;
			background: #313131;
			font-size: 13px;
			color: #b0b0b0;
			text-align: center;
		}
	}
</style>
